// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"style_modalBody__1qmrF"};